import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { NewPartnerTotals } from 'containers/PartnerAgreements';
import calculateContract from '../../helpers/calculateContract';
import * as styles from './AgreementPreview.scss';

var moment = require('moment');

var AgreementPreview = (_dec = connect(function (state) {
  return {
    contract: state.contract
  };
}, {}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(AgreementPreview, _Component);

  var _super = _createSuper(AgreementPreview);

  function AgreementPreview(props) {
    var _this;

    _classCallCheck(this, AgreementPreview);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "defaultProps", {
      signatureSection: null,
      isMultilocationContract: false,
      style: {},
      isAffiliateClientContract: false
    });

    _defineProperty(_assertThisInitialized(_this), "renderPartnerServiceDetails", function () {
      var c = _this.props.contract;
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", null, "partner service details"));
    });

    _defineProperty(_assertThisInitialized(_this), "renderServiceDetails", function () {
      var c = _this.props.contract; // this section only rendered for clients, so no need to check if partner here

      var cp = c.ContractProducts[0];

      var _calculateContract = calculateContract(c, cp, _this.props.isAffiliateClientContract),
          totalDueToday = _calculateContract.totalDueToday;

      var productsList = c.Products.map(function (p, index) {
        return _this.props.isAffiliateClientContract ? /*#__PURE__*/React.createElement("div", {
          key: index
        }, /*#__PURE__*/React.createElement("div", {
          className: styles.row
        }, /*#__PURE__*/React.createElement("div", {
          className: styles.mainArea
        }, /*#__PURE__*/React.createElement("span", {
          style: {
            fontSize: 17
          }
        }, p.title, " Package"), /*#__PURE__*/React.createElement("div", {
          className: styles.description
        }, p.description, " "), parseInt(p.adsBudget, 10) > 0 && /*#__PURE__*/React.createElement("div", {
          className: styles.description
        }, "Includes ", _this.formatCurrency(p.adsBudget, true), " monthly ads budget."))), /*#__PURE__*/React.createElement("div", {
          className: styles.row
        }, /*#__PURE__*/React.createElement("div", {
          className: styles.mainArea
        }, "Monthly Price"), /*#__PURE__*/React.createElement("div", {
          className: styles.endBit
        }, _this.formatCurrency(parseInt(p.retailMonthlyPrice, 10) + parseInt(p.adsBudget, 10), true)))) : /*#__PURE__*/React.createElement("div", {
          key: index
        }, /*#__PURE__*/React.createElement("div", {
          className: styles.row
        }, /*#__PURE__*/React.createElement("div", {
          className: styles.mainArea
        }, "Monthly Base Subscription Fee", /*#__PURE__*/React.createElement("div", {
          className: styles.description
        }, "The Base Plan grants access to Likeable Local\u2019s dashboard and feature set, Facebook, Instagram, LinkedIn, and Twitter integration, including posts created by Likeable Local. Also includes Social Media Optimization, detailed reporting, dedicated customer success manager, ads management, and ongoing strategic consulting.")), /*#__PURE__*/React.createElement("div", {
          className: styles.endBit
        }, _this.formatCurrency(c.ContractProducts[index].monthlyFee))), c.ContractProducts[index].monthlyCustomFee && c.ContractProducts[index].monthlyCustomFee > 0 ? /*#__PURE__*/React.createElement("div", {
          className: styles.row
        }, /*#__PURE__*/React.createElement("div", {
          className: styles.mainArea
        }, "Monthly Custom Strategy Fee", /*#__PURE__*/React.createElement("div", {
          className: styles.description
        }, "The Custom Strategy includes an initial Facebook Facelift, the creation of up to (4) custom, short-form Facebook posts per month, custom feature Facebook ads, and the opportunity to have a monthly custom strategy call with a dedicated Customer Service Representative.")), /*#__PURE__*/React.createElement("div", {
          className: styles.endBit
        }, _this.formatCurrency(c.ContractProducts[index].monthlyCustomFee))) : null, /*#__PURE__*/React.createElement("div", {
          className: styles.row
        }, /*#__PURE__*/React.createElement("div", {
          className: styles.mainArea
        }, "Monthly Facebook Ad Credits"), /*#__PURE__*/React.createElement("div", {
          className: styles.endBit
        }, _this.formatCurrency(c.ContractProducts[index].monthlyAdsBudget ? c.ContractProducts[index].monthlyAdsBudget : p.adsBudget))));
      });
      return /*#__PURE__*/React.createElement("div", {
        className: styles.serviceWrap
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          width: '100%'
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "".concat(styles.row, " ").concat(styles.headerRow)
      }, /*#__PURE__*/React.createElement("span", {
        className: "".concat(styles.mainArea, " ").concat(styles.header)
      }, "Description"), /*#__PURE__*/React.createElement("span", {
        className: "".concat(styles.endBit, " ").concat(styles.header)
      }, "Amount")), productsList, /*#__PURE__*/React.createElement("div", {
        className: styles.row
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.mainArea
      }, " One Time Setup Fee "), _this.props.isAffiliateClientContract ? /*#__PURE__*/React.createElement("div", {
        className: styles.endBit
      }, _this.formatCurrency(c.Products[0].retailSetupFee, true)) : /*#__PURE__*/React.createElement("div", {
        className: styles.endBit
      }, _this.formatCurrency(cp.setupFee))), /*#__PURE__*/React.createElement("div", {
        className: "".concat(styles.row, " ").concat(styles.bottomRow),
        style: {
          marginBottom: 0
        }
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.endBit,
        style: {
          lineHeight: '24px'
        }
      }, "Total: ", _this.formatCurrency(totalDueToday, true)))));
    });

    _defineProperty(_assertThisInitialized(_this), "formatCurrency", function (amount) {
      var cents = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var amountInDollars = cents ? amount / 100.0 : amount;
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2
      }).format(amountInDollars);
    });

    _defineProperty(_assertThisInitialized(_this), "renderNameAddressBlock", function () {
      var c = _this.props.contract;
      return /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.addressBlock
      }, /*#__PURE__*/React.createElement("span", {
        className: "col-xs-12"
      }, c.firstName, " ", c.lastName), c.businessName && /*#__PURE__*/React.createElement("span", {
        className: "col-xs-12"
      }, c.businessName), c.Address.address1 && /*#__PURE__*/React.createElement("span", {
        className: "col-xs-12"
      }, " ", c.Address.address1), c.Address.address2 && /*#__PURE__*/React.createElement("span", {
        className: "col-xs-12"
      }, c.Address.address2), /*#__PURE__*/React.createElement("span", {
        className: "col-xs-12"
      }, c.Address.locality && /*#__PURE__*/React.createElement("span", null, c.Address.locality), c.Address.locality && c.Address.region && /*#__PURE__*/React.createElement("span", null, ","), c.Address.region && /*#__PURE__*/React.createElement("span", {
        style: {
          paddingLeft: 2
        }
      }, c.Address.region), c.Address.postcode && /*#__PURE__*/React.createElement("span", {
        style: {
          paddingLeft: 8
        }
      }, c.Address.postcode)), c.phone && /*#__PURE__*/React.createElement("span", {
        className: "col-xs-12"
      }, c.phone), c.email && /*#__PURE__*/React.createElement("span", {
        className: "col-xs-12"
      }, c.email)));
    });

    _defineProperty(_assertThisInitialized(_this), "renderFinePrint", function (c, cp) {
      var _calculateContract2 = calculateContract(c, [cp]),
          totalDueToday = _calculateContract2.totalDueToday,
          monthlyFee = _calculateContract2.monthlyFee;

      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", null, "By typing your name as it appears on this agreement in the box below as your electronic signature, you\n            acknowledge that you are entering into an initial ".concat(cp.contractMonths, " months agreement at ").concat(_this.formatCurrency(monthlyFee / 100.0), " a month.  You also acknowledge that this Agreement cannot be cancelled within the\n            initial ").concat(cp.contractMonths, " months. After the initial Agreement period of ").concat(cp.contractMonths, " months is\n            over, you agree to be billed on a month-to-month basis on the closest corresponding day of the month that\n            matches your Agreement start date.  In order to cancel your subscription with Likeable Local after the\n            initial Agreement length of ").concat(cp.contractMonths, " months, you must give our Customer Success Team advance\n            notice of at least 30 days before the next billing date.  You can reach our Customer Success Team\n            at (212) 359-4342 or by emailing customersuccess@likeablelocal.com.  If we fail to receive notification at\n            least 30 days before the billing date, any charges incurred on the billing date cannot be refunded.\n            ")), /*#__PURE__*/React.createElement("span", null, "In addition, any monthly fees charged in advance beyond the commitment period of ".concat(cp.contractMonths, "\n            months cannot be refunded.  The number of months charged in advance will become the contracted period if\n            greater than the initial commitment term of ").concat(cp.contractMonths, " months.")));
    });

    _defineProperty(_assertThisInitialized(_this), "renderAffiliateClientFinePrint", function (c, cp) {
      var _calculateContract3 = calculateContract(c, [cp], true),
          totalDueToday = _calculateContract3.totalDueToday,
          monthlyFee = _calculateContract3.monthlyFee;

      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", null, "By typing your name as it appears on this agreement in the box below as your electronic signature, you\n            acknowledge that you are entering into an initial ".concat(cp.contractMonths, " months agreement at ").concat(_this.formatCurrency(monthlyFee / 100.0), " a month.  You also acknowledge that this Agreement cannot be cancelled within the\n            initial ").concat(cp.contractMonths, " months. After the initial Agreement period of ").concat(cp.contractMonths, " months is\n            over, you agree to be billed on a month-to-month basis on the closest corresponding day of the month that\n            matches your Agreement start date.  In order to cancel your subscription with Likeable Local after the\n            initial Agreement length of ").concat(cp.contractMonths, " months, you must give our Customer Success Team advance\n            notice of at least 30 days before the next billing date.  You can reach our Customer Success Team\n            at (212) 359-4342 or by emailing customersuccess@likeablelocal.com.  If we fail to receive notification at\n            least 30 days before the billing date, any charges incurred on the billing date cannot be refunded.\n            ")), /*#__PURE__*/React.createElement("span", null, "In addition, any monthly fees charged in advance beyond the commitment period of ".concat(cp.contractMonths, "\n            months cannot be refunded.  The number of months charged in advance will become the contracted period if\n            greater than the initial commitment term of ").concat(cp.contractMonths, " months.")));
    });

    _defineProperty(_assertThisInitialized(_this), "renderPartnerFinePrint", function (c, cp) {
      var _calculateContract4 = calculateContract(c),
          totalDueToday = _calculateContract4.totalDueToday;

      var monthText = parseInt(cp.contractMonths, 10) > 1 ? 'months' : 'month';
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", null, "By typing your name as it appears on this agreement in the box below as your electronic signature, you\n            acknowledge that you are entering into an initial ".concat(cp.contractMonths, " month agreement at\n            ").concat(_this.formatCurrency(totalDueToday / 100.0), " a month.  You also acknowledge that this Agreement cannot be cancelled within the\n            initial ").concat(cp.contractMonths, " ").concat(monthText, ". After the initial Agreement period of ").concat(cp.contractMonths, " ").concat(monthText, " is\n            over, you agree to be billed on a month-to-month basis on the closest corresponding day of the month that\n            matches your Agreement start date.\n            In order to cancel your subscription with Likeable Local after the initial Agreement length of ").concat(cp.contractMonths, " ").concat(monthText, ",\n            you must give our Partner Success Team advance notice of at least 30 days before the next billing\n            date. While you can email the Partner Success Team at ")), /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("a", {
        href: "mailto:partners@likeablelocal.com",
        title: "Email Us"
      }, "partners@likeablelocal.com"), " to alert them\n            of your intent to cancel, cancellation can only be confirmed over the phone. The Partner Success Team can\n            be reached at (212) 359-4342. If we fail to receive notification at\n            least 30 days before the billing date, any charges incurred on the billing date cannot be refunded.\n            "), /*#__PURE__*/React.createElement("span", null, "In addition, any monthly fees charged in advance beyond the commitment period of ".concat(cp.contractMonths, "\n            ").concat(monthText, " cannot be refunded.  The number of months charged in advance will become the contracted period if\n            greater than the initial commitment term of ").concat(cp.contractMonths, " ").concat(monthText, ".")));
    });

    _this.state = {
      totalDueToday: 0
    };
    return _this;
  }

  _createClass(AgreementPreview, [{
    key: "render",
    value: function render() {
      var c = this.props.contract;
      var cp = c.isPartner ? c.ContractPartners[0] : c.ContractProducts[0];

      var _calculateContract5 = calculateContract(c, cp, this.props.isAffiliateClientContract),
          totalDueToday = _calculateContract5.totalDueToday;

      return /*#__PURE__*/React.createElement("div", {
        className: styles.contractWrap,
        style: this.props.style,
        id: "AgreementPreview"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-xs-12"
      }, /*#__PURE__*/React.createElement("h2", {
        className: styles.contractHeader
      }, "Customer Order Information")), /*#__PURE__*/React.createElement("div", {
        className: ""
      }, /*#__PURE__*/React.createElement("span", {
        className: ""
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.startDate
      }, "Start Date: "), /*#__PURE__*/React.createElement("span", null, moment(c.contractStartsAt).format('MM/DD/YYYY')))), /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: 12
        }
      }, /*#__PURE__*/React.createElement("span", {
        className: ""
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.startDate
      }, "Agreement Length: "), /*#__PURE__*/React.createElement("span", null, cp.contractMonths, " Month", cp.contractMonths > 1 ? 's' : ''))), this.renderNameAddressBlock(), c.isPartner ? /*#__PURE__*/React.createElement("div", {
        className: styles.serviceWrap,
        style: {
          display: 'flex',
          flexDirection: 'column'
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "".concat(styles.row, " ").concat(styles.headerRow),
        style: {
          marginBottom: 0
        }
      }, /*#__PURE__*/React.createElement("span", {
        className: "".concat(styles.mainArea, " ").concat(styles.header),
        style: {
          flex: '1 0 75%'
        }
      }, "Description"), /*#__PURE__*/React.createElement("span", {
        className: "".concat(styles.endBit, " ").concat(styles.header),
        style: {
          flex: '0 1 25%',
          marginLeft: 0,
          textAlign: 'left'
        }
      }, "Amount")), /*#__PURE__*/React.createElement(NewPartnerTotals, {
        isAffiliateContract: this.props.isAffiliateContract,
        isMultilocationContract: this.props.isMultilocationContract,
        textStyle: {
          color: '#000000'
        },
        style: {
          flex: 1,
          margin: 0
        },
        formValues: cp
      })) : this.renderServiceDetails(), /*#__PURE__*/React.createElement("div", {
        className: "col-xs-12 ".concat(styles.finePrint)
      }, this.props.isAffiliateClientContract ? this.renderAffiliateClientFinePrint(c, cp) : c.isPartner ? this.renderPartnerFinePrint(c, cp) : this.renderFinePrint(c, cp)), this.props.signatureSection);
    }
  }]);

  return AgreementPreview;
}(Component)) || _class);
export { AgreementPreview as default };